namespace GeniuzPOS.AdvPromo {
    export enum ItemTypeFg {
        ItemTypeFg1 = 1,
        ItemTypeFg2 = 2,
        ItemTypeFg3 = 3
    }
    Serenity.Decorators.registerEnumType(ItemTypeFg, 'GeniuzPOS.AdvPromo.ItemTypeFg');
}
